import React, { useRef } from "react";
import { useHover } from "usehooks-ts";
import cn from "classnames";
import css from "./BarsChartItem.module.scss";
import { Tooltip } from "@infobis/ui-styles-utils";
import { BarsChartProps, Item } from "../../BarsChart";
import { omit } from "lodash";

export type Position = 'first' | 'last' | 'default' | 'single'

type BarsChartItemProps<ItemCustom extends Record<string, any> = {}> = {
	item: Item<ItemCustom>
	position: Position
	width: number
} & Pick<BarsChartProps<ItemCustom>, 'suppressTooltipStyles' | 'tooltipProps' | 'getTooltipText' | 'onItemClick' | 'height'>

const BarsChartItem = <ItemCustom extends Record<string, any> = {}>(props: BarsChartItemProps<ItemCustom>) => {
	const {
		onItemClick = () => {},
		getTooltipText = () => '',
		item,
		height,
		position,
		tooltipProps = {},
		suppressTooltipStyles = false,
		width
	} = props;

	const hoverRef = useRef(null)
	const isHover = useHover(hoverRef)

	const clsName = cn(css['item'], css[`item--${position}`])

	const onClick = (e: React.MouseEvent) => {
		e.stopPropagation()
		onItemClick(item)
	}

	return (
		<Tooltip trigger={'sticky'}
				 text={getTooltipText(item)}
				 targetStyle={{ width, maxWidth: width, minWidth: width }}
				 targetClass={css['item-target']}
				 style={{ zIndex: 99999, ...(tooltipProps.style || {}) }}
				 { ...omit(tooltipProps, 'className', 'style') }
				 className={cn(suppressTooltipStyles && css['tooltip--without-wrapper'], tooltipProps.className)}
		>
			<div onClick={onClick}>
				<div
					style={{ backgroundColor: item.color, width, height: height + 6 }}
					className={cn(clsName, css['item-bg'], isHover && css['item-bg--hovered'])}
				/>
				<div
					ref={hoverRef}
					className={clsName}
					style={{ backgroundColor: item.color, width, height }}
				/>
			</div>
		</Tooltip>
	)
}

export default BarsChartItem;